import { render, staticRenderFns } from "./SidebarAttachmentsBlock.vue?vue&type=template&id=14540271&scoped=true"
import script from "./SidebarAttachmentsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarAttachmentsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarAttachmentsBlock.vue?vue&type=style&index=0&id=14540271&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14540271",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14540271')) {
      api.createRecord('14540271', component.options)
    } else {
      api.reload('14540271', component.options)
    }
    module.hot.accept("./SidebarAttachmentsBlock.vue?vue&type=template&id=14540271&scoped=true", function () {
      api.rerender('14540271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarAttachmentsBlock.vue"
export default component.exports